// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import utils from './libs/utils'
import './assets/css/reset.css'
import './assets/icon/iconfont.css'
import './assets/css/common.less'
import 'mint-ui/lib/style.css'
import MintUI from 'mint-ui'

Vue.config.productionTip = false

utils.adoptdevice(750, 100, 16)
window.addEventListener('resize', function () {
  utils.adoptdevice(750, 100, 16)
})

Vue.use(MintUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js